import React from 'react';

import AuthUserContext from './context';
import {withFirebase} from '../Firebase';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Grid} from '@theme-ui/components';

const withAuthentication = Component => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                authUser: null,
                showPinModal: false,
                pin: '',
                twoStepAuthCode: '',
                authUserBack: null,
                isLoading: true
            };
        }

        handleClose = () => {
            this.setState({showPinModal: false});
            this.props.firebase.doSignOut();
        }

        handleShow = () => {
            this.setState({showPinModal: true});
        }

        onChange = (event) => {
            this.setState({pin: event.target.value});
        }

        handlePinEnter = () => {
            this.setState({showPinModal: false});
            if (this.state.pin === this.state.twoStepAuthCode) {
                // pass him to signin
                localStorage.setItem('localStoragePin', this.state.pin);
                this.setState({authUser: this.state.authUserBack});
            } else {
                // sign out
                this.props.firebase.doSignOut();
            }
        }

        componentDidMount() {
            this.listener = this.props.firebase.auth.onAuthStateChanged(
                authUser => {
                    if (authUser !== null) {
                        this.props.firebase.company(authUser.uid).get().then(docSnapshot => {
                            let company = docSnapshot.data();
                            if (company.enableTwoStepAuth === true && localStorage.getItem('localStoragePin') !== company.twoStepAuthCode) {
                                this.setState({
                                    showPinModal: true,
                                    twoStepAuthCode: company.twoStepAuthCode,
                                    authUserBack: authUser,
                                    isLoading: false
                                })
                            } else {
                                this.setState({authUser, isLoading: false});
                            }
                        }, err => {
                            this.setState({isLoading: false});
                            this.props.firebase.doSignOut();
                        });
                    } else {
                        this.setState({authUser: null, isLoading: false});
                    }
                },
            );
        }

        componentWillUnmount() {
            this.listener();
        }

        render() {
            const {showPinModal, authUser, pin, authUserBack, isLoading} = this.state;

            if (isLoading) {
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        backgroundColor: '#f9fafb'
                    }}>
                        <div style={{textAlign: 'center'}}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                border: '4px solid #e5e7eb',
                                borderTop: '4px solid #3b82f6',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 16px'
                            }} />
                            <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            <p style={{color: '#6b7280', fontSize: '14px'}}>Učitavanje...</p>
                        </div>
                    </div>
                );
            }

            return (
                <AuthUserContext.Provider value={authUser}>
                    <Component {...this.props} />
                    <Modal show={showPinModal} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Enter the PIN</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <form>
                                <Grid columns={[1, null, 1]}>
                                    <input
                                        name="pin"
                                        value={pin}
                                        onChange={this.onChange}
                                        type="password"
                                        placeholder="PIN"
                                    />
                                </Grid>
                            </form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" onClick={this.handlePinEnter}>
                                Ok
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </AuthUserContext.Provider>
            );
        }
    }

    return withFirebase(WithAuthentication);
};

export default withAuthentication;